import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormControl } from 'react-bootstrap';

import Modal from '~/App/Components/Modal';

export default function EditNameModal({
  isOpen = false,
  onConfirm,
  onRequestClose,
  defaultValue,
}) {
  const [name, setName] = useState(defaultValue);

  function handleConfirmClick() {
    if (typeof onConfirm == 'function') {
      onConfirm(name);
    }

    onRequestClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      onConfirmClick={handleConfirmClick}
    >
      <div className='sub-heading'>Give your template a name</div>
      <p className='body-copy'>
        Naming will help with testing different messages
      </p>
      <p>
        <FormControl
          placeholder='New onboarding template'
          defaultValue={defaultValue}
          onChange={(e) => setName(e.target.value)}
        />
      </p>
    </Modal>
  );
}

EditNameModal.propTypes = {
  isOpen: PropTypes.bool,
  defaultValue: PropTypes.string,

  onConfirm: PropTypes.func,
  onRequestClose: PropTypes.func,
};
